import { productForSkuIdSelector, upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { useSelector } from 'react-redux';
import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import { Flex } from 'foundations-components/components/Flex';
import { SCREENS } from '../../constants/tracking/Screens';
import { ADD_ON_CARD, APP } from '../../constants/tracking/TrackingSources';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddOnCardCTAFallback = ({
  skuId,
  trackingSource
}) => {
  const {
    apiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const upgradeData = {
    app: APP,
    screen: SCREENS.PRODUCTS_PLANS,
    uniqueId: `${trackingSource || ADD_ON_CARD}-${upgradeProduct}`,
    upgradeProduct
  };
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    children: /*#__PURE__*/_jsx(UIContactSalesButton, {
      apiName: apiName,
      upgradeData: upgradeData,
      use: "primary",
      block: true
    })
  });
};
export const AddOnCardPricingFallback = () => null;